import { gql } from 'graphql-request'

import { ScheduledCommunicationQueries } from '../queries/scheduledCommunications.queries'

export namespace ScheduledCommunicationMutations {
  export function updateScheduledCommunication() {
    return gql`
      mutation updateScheduledCommunication($scheduledCommunication: ScheduledCommunicationUpdateMutation) {
        updateScheduledCommunication(scheduledCommunication: $scheduledCommunication) {
          ...ScheduledCommunicationSummary
        }
      }
      ${ScheduledCommunicationQueries.SCHEDULED_COMMUNICATION_SUMMARY}
    `
  }
}
